<template>
  <div ref="tooltipBox" class="ElThTooltipBox">
    <div class="tooltipStandardBox" ref="tooltipStandardBox" style="white-space: nowrap">{{ data }}</div>
    <el-tooltip v-if="isTooltipBox" popper-class="MyelTooltip" :placement="placement ? placement : 'top'" effect="dark" :content="data">
      <div ref="copyEl2" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 100%;" :class="{ copy }" @click="copyFn">{{ data }}</div>
    </el-tooltip>
    <div v-if="!isTooltipBox" ref="copyEl1" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 100%;" :class="{ copy }" @click="copyFn">{{ data }}</div>
  </div>
</template>

<script>
export default {
  name: "ElThTooltip",
  props: ["data", "placement", "copy"],
  data() {
    return {
      isTooltipBox: false,
      resizeObserver: null,
    };
  },
  watch: {
    data: {
      handler(newV) {
        if (newV) {
          this.$nextTick(() => {
            this.initResizeObserver();
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    initResizeObserver() {
      // data 每变一次都会进来；先断开旧的，否则列表复用组件时监听器越积越多
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (this.$refs.tooltipStandardBox) {
            this.isTooltipBox = this.$refs.tooltipStandardBox.offsetWidth > Math.ceil(entry.contentRect.width);
          }
        }
      });
      this.resizeObserver.observe(this.$refs.tooltipBox);
    },
    copyFn() {
      if (this.copy) {
        var copyEl = null;
        if (this.$refs.copyEl2) {
          copyEl = this.$refs.copyEl2.innerText;
        }
        if (this.$refs.copyEl1) {
          copyEl = this.$refs.copyEl1.innerText;
        }
        if (copyEl) {
          this.copyWithSelection(copyEl);
        }
      }
    },
    copyWithSelection(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, text.length);
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$toast.clear();
      this.$toast.success(this.$t("copySuccess"), {
        toastClassName: "custom-success-toast",
      });
    },
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
};
</script>

<style scoped lang="scss">
.ElThTooltipBox {
  position: relative;
  .tooltipStandardBox {
    position: absolute;
    top: -100000000px;
    left: -100000000px;
    opacity: 0;
    width: auto !important;
  }
  .copy {
    cursor: pointer;
  }
}
</style>
<style>
.MyelTooltip{
  max-width: 300px;
  white-space: wrap;
}
</style>
